import {Component, Input, OnInit} from '@angular/core';
import {aggregateHardawareDetailDevice, sensorDataType} from "../../providers/service/global-variables.service";
import {isNotNullOrUndefined} from "../../providers/service/global-variables.service";

@Component({
    selector: 'app-box-device',
    templateUrl: './box-device.component.html',
    styleUrls: ['./box-device.component.scss'],
    standalone: false
})
export class BoxDeviceComponent implements OnInit {

    constructor() {
    }

    @Input()
    device: aggregateHardawareDetailDevice | undefined;
    @Input()
    selected: boolean = false;
    @Input()
    disable: boolean = false;

    allSensorDataType = sensorDataType;

    ngOnInit(): void {
    }


    getKeyTrad(key: string): string {
        return 'unitOfMeasurement.' + key + '.traduction';
    }


    getActivedClass(classActived: boolean): boolean {
        return !this.selected && classActived;
    }


    addPhoto(event: Event) {
        event.stopPropagation();
    }

    get sensorDataTypeIsTemperature() {
        return isNotNullOrUndefined(this.device) && isNotNullOrUndefined(this.device?.sensorDataTypes) && this.device?.sensorDataTypes.includes(this.allSensorDataType.temperature)
    }

    public indexData = 0;

    get sensorDataType(): string {
        if (isNotNullOrUndefined(this.device) && isNotNullOrUndefined(this.device?.sensorDataTypes)) {
            return this.device?.sensorDataTypes[this.indexData]!;
        } else {
            return this.allSensorDataType.powerConsuption
        }
    }

    get sensorDataValue(): number {
        if (isNotNullOrUndefined(this.device) && isNotNullOrUndefined(this.device?.sensorDataValues)) {
            return this.device?.sensorDataValues[this.indexData]!;
        } else {
            return 0
        }
    }

    get differenceHourWithNow(): number {
        if (isNotNullOrUndefined(this.device) && isNotNullOrUndefined(this.device?.sensorDataDates) && isNotNullOrUndefined(this.device?.sensorDataDates[this.indexData])) {
            const differenceWithNow = Date.now() - this.device?.sensorDataDates[this.indexData]!.getTime()!;
            const differenceH = Math.round(differenceWithNow / 1000 / 3600);
            return differenceH;
        } else {
            return 0
        }
    }

    clickTemperature() {
        this.indexData++;
        this.indexData = this.indexData % this.device?.sensorDataTypes.length!;
    }
}
